import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-citation-sample-report',
  templateUrl: './citation-sample-report.component.html',
  styleUrls: ['./citation-sample-report.component.scss']
})
export class CitationSampleReportComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

  showText(event, tagCount) {
    if (event.target.closest('ul').className == ''){
      event.target.closest('ul').classList.add('limitText');
      event.target.closest('span').innerText = "+"+(tagCount-1)+" More";
    }else{
      event.target.closest('ul').classList.remove('limitText');
      event.target.closest('span').innerText =  "Less";
    } 
  } 

}
